export class AddressAutocompletionEventConfig {
  name: string;
  streetField: HTMLInputElement;
  countryField: HTMLInputElement;
  postalCodeField: HTMLInputElement;
  cityField: HTMLInputElement;
  suggestionElement: HTMLDivElement;
  suggestionListElement: HTMLDivElement;
  hintElement: HTMLDivElement;
}
